import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Home.module.css";
import BaseUrlSelect from "./BaseUrlSelect/BaseUrlSelect";

const Home = () => {
  const navigate = useNavigate();
  // useEffect(() => {
  //   navigate("/admin/login");
  // }, []);
  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        <span>Ｚzｚ゜。(_　_) </span>
        <span> WELCOME </span>
        <span> (_　_)。゜zｚＺ </span>
      </div>
      {/* <p onClick={() => navigate("/admin/login")}> Navigate to Admin Login</p> */}
      <div className={classes.systemsContainer}>
        <div className={classes.system} onClick={() => navigate("/admin/login")}>
          ERP System
        </div>
        <div
          className={classes.system}
          onClick={() => navigate("/personnel-document-digitization/login")}
        >
          PDD System
        </div>
        <div className={classes.system} onClick={() => navigate("/applicant-information/login")}>
          Applicant System
        </div>
        <div
          className={classes.system}
          onClick={() => navigate("/sale-representatives-management/login")}
        >
          SRM System
        </div>
        <div
          className={classes.system}
          onClick={() => {
            window.open("https://cmit.lafarrerr.com:24488", "_blank");
          }}
        >
          SSO System
        </div>
        <div className={classes.system} onClick={() => navigate("/form-network-marketer/login")}>
          Network Marketer
        </div>
      </div>
      {process.env.NODE_ENV === "development" && process.env.NODE_ENV !== "production" ? (
        <BaseUrlSelect />
      ) : null}
    </div>
  );
};

export default Home;
